import {
  Box,
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import iconClose from "../../assets/images/projectManagement/icon-close.svg";

import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import { formatDateDb } from "../../utils/tools";
import { formatNumber } from "../../utils/utils";
const PopupSaleOpeningEvent = ({
  isOpen,
  onClose,
  defaultValue,
  idData,
}) => { 
  const [data, setData] = useState([]);

  useEffect(() => {
    if (idData) {
      const fetchData = async () => {
        try {
          const saleOpeningEvent = await saleOpeningEventCall.getId(idData);
          if (saleOpeningEvent) {
            setData(saleOpeningEvent || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }

    if(defaultValue){
        setData(defaultValue);
    }
  }, [idData, defaultValue]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"625px"}
        maxH={"88vh"}
        overflow="auto"
      >
        <Flex
          borderBottom={"1px solid var(--color-boder)"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"24px 20px 24px 24px"}
        >
          <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
            Chi tiết đợt mở bán
          </Text>
          <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
        </Flex>
        <Box p={"0px 40px 24px 40px"}>
          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Mã đợt mở bán
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.code || "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tên đợt mở bán
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.name || "-"}
              </Text>
            </Box>
          </Flex>
          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Tên dự án
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.project?.name || data?.projectName || ""}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Số sản phẩm
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.apartmentSaleOpeningEventLink?.length || data?.product || "0"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Thời gian bắt đầu
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.startTime ? formatDateDb(data?.startTime) : "-"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Thời gian kết thúc
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.endTime ? formatDateDb(data?.endTime) :"-"}
              </Text>
            </Box>
          </Flex>

          <Flex gap={"27px"} mt={"16px"}>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Số tiền đặt cọc
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.price ? `${formatNumber(data?.price)} VNĐ` : "0 VNĐ"}
              </Text>
            </Box>
            <Box flex={"1"}>
              <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                Nhân viên tạo
              </Text>
              <Text
                color={"var(--color-option-employee)"}
                fontSize={"14px"}
                fontWeight={"500"}
                mt={"8px"}
              >
                {data?.creator?.fullName || data?.creator || "-"}
              </Text>
            </Box>
          </Flex>

        </Box>
      </ModalContent>
    </Modal>
  );
};

export default PopupSaleOpeningEvent;
